/* eslint-disable import/prefer-default-export */

import { isInsideAppContainer } from './vmFunctions/others';

export const sendUserInfoToContainer = (userObj = {}) => {
  if (isInsideAppContainer()) {
    const { user_id: userId, access_token: accessToken } = userObj ?? {};
    const message = 'fcm-user-login';
    const messageObj = { message, userId, accessToken };
    const stringifiedMessageObj = JSON.stringify(messageObj);
    window.webkit.messageHandlers.cordova_iab.postMessage(
      stringifiedMessageObj
    );
  }
};
